import React from 'react'
import styled from "styled-components"

const StyledLink = styled.span`
  text-decoration: underline;
  cursor: ${props => props.cursor};
`

const Link = ({content = "", onClick = null, cursor = "unset"}) => {
    return <StyledLink onClick={onClick} cursor={cursor}>{content}</StyledLink>
}

export default Link
